import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';

import { OTP_GENERATE, OTP_VALIDATE} from '@/forms/constants/services';

export default {
  sendOtpCode(appId) {
    var data=appId.split(",");
    return Repository.post('/onboarding/otpgenerate/v1.0', {
      'app-id': data[0],
      'validation-type': 'mobilephone',
       'name': data[1]

    }, {
      params: getParams(OTP_GENERATE),
    });
  },
  sendOtpCodeV2(mobile) {
    return Repository.post('/onboarding/otpgenerate/v2.0', {
      'target':mobile,
      'validation-type': 'mobilephone',
      'source':'onboarding'

    }, {
      params: getParams(OTP_GENERATE),
    });
  },
  sendOtpCodeV3(phoneNumer) {
    var data=phoneNumer.split(",");
    return Repository.post('/onboarding/otpgenerate/v3.0', {
      'app-id':data[0],
      'target':data[1],
      'validation-type': 'mobilephone',

    }, {
      params: getParams(OTP_GENERATE),
    });
  },
  validateOtpCode(payload) {
    return Repository.post('/onboarding/otpvalidate/v1.0', { ...payload }, {
      params: getParams(OTP_VALIDATE),
    });
  },
  validateOtpCodeV2(payload) {
    return Repository.post('/onboarding/otpvalidate/v2.0', { ...payload }, {
      params: getParams(OTP_VALIDATE),
    });
  },
  validateOtpCodeV3(payload) {
    return Repository.post('/onboarding/otpvalidate/v3.0', { ...payload }, {
      params: getParams(OTP_VALIDATE),
    });
  },
  validateChekV3(payload) {
    return Repository.post('/onboarding/otpvalidatecheck/v3.0', { ...payload }, {
      params: getParams(OTP_VALIDATE),
    });
  },
};
